// import React from 'react';

// const TableBlock = ({ block, onChange }) => {
//   const updateCell = (rowIndex, colIndex, value) => {
//     const updated = [...block.rows];
//     updated[rowIndex][colIndex] = value;
//     onChange({ ...block, rows: updated });
//   };

//   const addRow = () => {
//     const cols = block.rows[0]?.length || 1;
//     onChange({ ...block, rows: [...block.rows, Array(cols).fill('')] });
//   };

//   const addColumn = () => {
//     const updated = block.rows.map(row => [...row, '']);
//     onChange({ ...block, rows: updated });
//   };

//   return (
//     <div>
//       <table border="1">
//         <tbody>
//           {block.rows.map((row, rowIndex) => (
//             <tr key={rowIndex}>
//               {row.map((cell, colIndex) => (
//                 <td key={colIndex}>
//                   <input
//                     value={cell}
//                     onChange={(e) => updateCell(rowIndex, colIndex, e.target.value)}
//                   />
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       <button onClick={addRow}>Add Row</button>
//       <button onClick={addColumn}>Add Column</button>
//     </div>
//   );
// };

// export default TableBlock;

import React, { useState } from 'react';
import styles from './TableBlock.module.css';
import FormattingToolbar from './FormattingToolbar';

const TableBlock = ({ block, onChange }) => {
  const [selectedCell, setSelectedCell] = useState({ row: null, col: null });

  const updateCell = (rowIndex, colIndex, value) => {
    const updated = [...block.rows];
    updated[rowIndex][colIndex] = value;
    onChange({ ...block, rows: updated });
  };

  const handleCellClick = (row, col) => {
    setSelectedCell({ row, col });
  };

  const formatSelectedCell = (tag) => {
    const { row, col } = selectedCell;
    if (row === null || col === null) return;
    const cellContent = block.rows[row][col];

    // Toggle logic: if already wrapped, remove it
    const regex = new RegExp(`^<${tag}>(.*)</${tag}>$`);
    const match = cellContent.match(regex);
    const newContent = match ? match[1] : `<${tag}>${cellContent}</${tag}>`;

    updateCell(row, col, newContent);
  };

  const addRow = () => {
    const cols = block.rows[0]?.length || 1;
    onChange({ ...block, rows: [...block.rows, Array(cols).fill('')] });
  };

  const addColumn = () => {
    const updated = block.rows.map(row => [...row, '']);
    onChange({ ...block, rows: updated });
  };

  return (
    <div className={styles.container}>
      <div className={styles.toolbarTop}>
        <FormattingToolbar onFormat={formatSelectedCell} />
      </div>

      <table className={styles.table}>
        <tbody>
          {block.rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, colIndex) => {
                const isSelected = selectedCell.row === rowIndex && selectedCell.col === colIndex;
                return (
                  <td
                    key={colIndex}
                    onClick={() => handleCellClick(rowIndex, colIndex)}
                    className={isSelected ? styles.selectedCell : ''}
                  >
                    <input
                      className={styles.inputCell}
                      value={cell}
                      onChange={(e) => updateCell(rowIndex, colIndex, e.target.value)}
                    />
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>

      <div className={styles.buttons}>
        <button onClick={addRow}>Add Row</button>
        <button onClick={addColumn}>Add Column</button>
      </div>
    </div>
  );
};

export default TableBlock;
